function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { NpsModal } from '@appsource/components/modals';
import { getNpsModule } from '@appsource/utils/nps';
import { getWindow } from '@shared/services/window';
import { Constants } from '@shared/utils/constants';
import { storeFeedback } from '@shared/services/feedback';
import { logger } from '@src/logger';
export const Nps = ({ email, correlationId, context, isConverged })=>{
    const showPreviewModalRef = useRef(false);
    useEffect(()=>{
        var _getNpsModule;
        const payload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.NPS,
            actionModifier: Constants.Telemetry.ActionModifier.NpsPresented,
            details: JSON.stringify(_object_spread_props(_object_spread({}, ((_getNpsModule = getNpsModule()) === null || _getNpsModule === void 0 ? void 0 : _getNpsModule.metadata) || {}), {
                previewModal: showPreviewModalRef.current
            }))
        };
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier
        });
    }, []);
    const handleSubmit = (answer)=>{
        var _getNpsModule;
        (_getNpsModule = getNpsModule()) === null || _getNpsModule === void 0 ? void 0 : _getNpsModule.npsSubmitted();
        const userTelemetryPayload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.NPS,
            actionModifier: Constants.Telemetry.ActionModifier.NpsSurveySubmitted,
            details: JSON.stringify({
                previewModal: showPreviewModalRef.current
            })
        };
        const userFeedbackPayload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.NPS,
            actionModifier: Constants.Telemetry.ActionModifier.Info,
            details: JSON.stringify(_object_spread_props(_object_spread({}, answer), {
                rating: `${answer.rating}`,
                previewModal: showPreviewModalRef.current
            })),
            isFeedback: true
        };
        logger.info(userTelemetryPayload.details, {
            action: userTelemetryPayload.action,
            actionModifier: userTelemetryPayload.actionModifier
        });
        storeFeedback({
            action: userFeedbackPayload.action,
            actionModifier: userFeedbackPayload.actionModifier,
            details: userFeedbackPayload.details
        });
    };
    const handleDismissPreview = ()=>{
        var _getNpsModule;
        (_getNpsModule = getNpsModule()) === null || _getNpsModule === void 0 ? void 0 : _getNpsModule.npsDismissed();
        const payload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.NPS,
            actionModifier: Constants.Telemetry.ActionModifier.NpsPreviewDismissed,
            details: ''
        };
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier
        });
    };
    const handleDismissSurvey = ()=>{
        var _getNpsModule;
        (_getNpsModule = getNpsModule()) === null || _getNpsModule === void 0 ? void 0 : _getNpsModule.npsDismissed();
        const payload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.NPS,
            actionModifier: Constants.Telemetry.ActionModifier.NpsSurveyDismissed,
            details: ''
        };
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier
        });
    };
    return /*#__PURE__*/ _jsx(NpsModal, {
        isConverged: isConverged,
        email: email,
        showPreviewModal: showPreviewModalRef.current,
        onDismissPreview: handleDismissPreview,
        onDismissSurvey: handleDismissSurvey,
        onSubmitted: handleSubmit,
        correlationId: correlationId,
        context: context
    });
};
